import { useCallback, useMemo } from 'react';
import { useGetHotelSuppliers } from '@frontend/features/hotel-content-manager/queries';

export const useHotelMetadata = () => {

  const {data: suppliers, isLoading: suppliersLoading} = useGetHotelSuppliers({
    currentPage: 1,
    pageSize: 10000,
  });


  const handleFindSupplier = useCallback((supplierId: number) => suppliers?.items.find(
    (supplier) => supplier.id === supplierId
  ), [suppliers]);
  
  const handleFindSupplierByAccessCode = useCallback((access: string) => suppliers?.items.find(
    (supplier) => supplier.accessCode === access
  ), [suppliers]);

  const handleFindSupplierByContext = useCallback((context: string) => suppliers?.items.find(
    (supplier) => supplier.supplierCode === context
  ), [suppliers]);

  const result =  useMemo(() => ({
    isLoading: suppliersLoading,
    suppliers: suppliers?.items || [],
    findSupplier: handleFindSupplier,
    findSupplierByAccessCode: handleFindSupplierByAccessCode,
    findSupplierByContext: handleFindSupplierByContext,
  }), [suppliersLoading, suppliers]);

  return result;
};
